import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment, useContext, useEffect } from 'react';
import LoadingBlock from '../Common/LoadingBlock';
import MeetingSelector from './MeetingSelector';
import MeetingWarning from './MeetingWarning';
import { MeetingsContext } from './MeetingsContext';
import useMeetings, { useSelectedMeeting, useSelectedMeetingCalendar, } from './useMeetings';
import HubspotWrapper from '../Common/HubspotWrapper';
import ErrorHandler from '../Common/ErrorHandler';
import { pluginPath } from '../../constants/leadinConfig';
import { __ } from '@wordpress/i18n';
export default function MeetingController({ handleChange, }) {
    const { loading, selectedMeeting, error, reload } = useContext(MeetingsContext);
    const meetings = useMeetings();
    const selectedMeetingOption = useSelectedMeeting();
    const selectedMeetingCalendar = useSelectedMeetingCalendar();
    useEffect(() => {
        if (!selectedMeeting && meetings.length > 0) {
            handleChange(meetings[0].value);
        }
    }, [meetings, selectedMeeting, handleChange]);
    const handleLocalChange = (option) => {
        handleChange(option.value);
    };
    return (_jsx(Fragment, { children: loading ? (_jsx(LoadingBlock, {})) : error ? (_jsx(ErrorHandler, { status: (error && error.status) || error, resetErrorState: () => reload(), errorInfo: {
                header: __('There was a problem retrieving your meetings', 'leadin'),
                message: __('Please refresh your meetings or try again in a few minutes.', 'leadin'),
                action: __('Refresh meetings', 'leadin'),
            } })) : (_jsxs(HubspotWrapper, { padding: "90px 32px 24px", pluginPath: pluginPath, children: [selectedMeetingCalendar && (_jsx(MeetingWarning, { status: selectedMeetingCalendar, triggerReload: () => reload() })), meetings.length > 1 && (_jsx(MeetingSelector, { onChange: handleLocalChange, options: meetings, value: selectedMeetingOption }))] })) }));
}
